import AdminRequest from './AdminRequest';

/**
 * Provides a set of CRUD operations around API: /credentials
 */
export default class TriggersClient extends AdminRequest {
	constructor() {
		super('/triggers/definitions');
	}

	getDefinitions() {
		return this._op('get', this.uri);
	}
}
